import React from "react";

const StatsNavTab = () => {
    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_nft_settings_main_bottom">
                        <div className="_nft_settings_main_bottom_heading">
                            <ul className="_nft_settings_main_bottom_ul nav nav-pills mb-3" id="pills-tab"
                                role="tablist">
                                <li className="_stat_nav_item nav-item" role="presentation">
                                    <button className="nav-link active" id="alltab" data-bs-toggle="pill"
                                        data-bs-target="#pillsonsale" type="button" role="tab"
                                        aria-controls="pills-home" aria-selected="true">All</button>
                                </li>
                                <li className="_stat_nav_item nav-item" role="presentation">
                                    <button className="nav-link" id="followtab" data-bs-toggle="pill"
                                        data-bs-target="#followingtab" type="button" role="tab"
                                        aria-controls="pills-profile" aria-selected="false">Following</button>
                                </li>
                                <li className="_stat_nav_item nav-item" role="presentation">
                                    <button className="nav-link" id="activitytab" data-bs-toggle="pill"
                                        data-bs-target="#myactivity" type="button" role="tab"
                                        aria-controls="pills-contact" aria-selected="false">My activity</button>
                                </li>
                                <li className="_stat_nav_item nav-item" role="presentation">
                                    <button className="nav-link" id="bidstab" data-bs-toggle="pill"
                                        data-bs-target="#mybids" type="button" role="tab"
                                        aria-controls="pills-contact" aria-selected="false">My bids</button>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_creator_top_right">
                        <div className="btn-group _creator_top_right_btn_wrap">
                            <button className="btn dropdown-toggle _creator_top_right_btn" type="button"
                                id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true"
                                aria-expanded="false">
                                Featured
                            </button>
                            <ul className="dropdown-menu _creator_top_btn_drop" aria-labelledby="defaultDropdown">
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">Best selling</a>
                                </li>
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">Popular items</a>
                                </li>
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">New items</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default StatsNavTab;